var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashSaleCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65824 22.9371C8.49679 22.8693 8.36262 22.7498 8.27691 22.5976C8.1912 22.4453 8.15882 22.269 8.18488 22.0964L9.62075 12.7858H5.81016C5.68935 12.7891 5.56941 12.7646 5.4596 12.7144C5.34978 12.6642 5.25302 12.5895 5.17679 12.4961C5.10055 12.4027 5.04687 12.2931 5.0199 12.1758C4.99293 12.0585 4.99338 11.9365 5.02122 11.8194L7.38805 1.60527C7.42969 1.42949 7.53088 1.27336 7.67457 1.16317C7.81827 1.05298 7.9957 0.995454 8.17699 1.00028H16.0664C16.1843 0.999882 16.3007 1.02579 16.4072 1.0761C16.5137 1.1264 16.6075 1.19983 16.6818 1.29099C16.7571 1.38318 16.8104 1.49118 16.8377 1.60686C16.8651 1.72254 16.8657 1.84288 16.8396 1.95884L15.4747 8.07162H19.2222C19.37 8.07132 19.515 8.11242 19.6406 8.19022C19.7661 8.26801 19.8672 8.37938 19.9322 8.51161C19.9888 8.63854 20.0105 8.77811 19.9953 8.91613C19.98 9.05414 19.9283 9.18567 19.8454 9.29732L9.58919 22.6543C9.51988 22.7566 9.42733 22.8412 9.31904 22.9013C9.21075 22.9614 9.08978 22.9952 8.96593 23C8.86036 22.998 8.75606 22.9767 8.65824 22.9371Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashSaleCustomize);
export default __webpack_public_path__ + "static/media/flash-sale-customize.db20c4301ea49d88d381e848423ca650.svg";
export { ForwardRef as ReactComponent };